var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js/pure';
import { connect } from 'react-redux';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { compose } from 'redux';
import * as actions from '../../store/orgDevPlan/actions';
import { makeSelectDevPlans, selectFilterdDevPlans, makeSelectActiveDeveloperPlan, selectProRatedAmount, selectProRatedAmountLoading, selectProRatedAmountError, } from '../../store/orgDevPlan/selectors';
import { makeSelectOrganization } from '../Root/selectors';
import { setShowModals } from '../Root/actions';
import { useErrorToast } from '../../utils/hooks/toast';
import DevPlanConfirmModal from '../../components/DeveloperPlans/DevPlanConfirmModal';
import DevPlanUpdateModal from '../../components/DeveloperPlans/DevPlanUpdateModal';
import { setCurrentStep, setSelectedDevPlan, } from '../../store/configureAccount/actions';
import { NAVIGATE_STEP_KEYS } from '../../store/configureAccount/types';
import { Helmet } from 'react-helmet';
import { PageContent, PageHeader, PageHeaderTitle, PageWrapper, } from '../../components/Page';
import Breadcrumbs from '../../components/OrgBreadcrumbs';
import DevPlanCardWrapper from '../../components/DeveloperPlans/DevPlanCardWrapper';
import { useDispatch } from 'react-redux';
import { selectDevPlanSummery, selectPaymentSummery, } from '../../store/orgStatusSummery/selectors';
import { checkOrgStatusSummery } from '../../store/orgStatusSummery/actions';
var OrganizationDeveloperPlans = function (_a) {
    var listDeveloperPlans = _a.listDeveloperPlans, organization = _a.organization, purchaseDeveloperPlansOrg = _a.purchaseDeveloperPlansOrg, developerPlans = _a.developerPlans, developerPlans_loading = _a.developerPlans_loading, developerPlanPurchase_error = _a.developerPlanPurchase_error, devPlanStatus = _a.devPlanStatus, developerPlanPurchase_loading = _a.developerPlanPurchase_loading, interval = _a.interval, changeInterval = _a.changeInterval, paymentDetails = _a.paymentDetails, setShowModals = _a.setShowModals, purchasedDeveloperPlan = _a.purchasedDeveloperPlan, setSelectedDevPlanId = _a.setSelectedDevPlanId, activeDeveloperPlan = _a.activeDeveloperPlan, getProRatedAmount = _a.getProRatedAmount, proRatedAmount = _a.proRatedAmount, proRatedAmountLoading = _a.proRatedAmountLoading, proRatedAmountError = _a.proRatedAmountError;
    var params = useParams();
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var dispatch = useDispatch();
    var _b = params.organizationId, organizationId = _b === void 0 ? '' : _b;
    var _c = useState(false), openDevPlanConfirmModal = _c[0], setOpenDevPlanConfirmModal = _c[1];
    var _d = useState(false), openDevPlanUpdateModal = _d[0], setOpenDevPlanUpdateModal = _d[1];
    var _e = useState(), selectedPlan = _e[0], setSelectedPlan = _e[1];
    var stripeKey = process.env.STRIPE_KEY;
    var stripePromise = loadStripe(stripeKey || '');
    var crumbs = [{ to: '', text: 'Developer Plans' }];
    if (organizationId) {
        var organizationName = organization ? organization.name : 'Loading...';
        crumbs = [
            {
                to: '/organizations',
                text: 'Organizations',
            },
            {
                to: "/organizations/".concat(organizationId),
                text: organizationName,
            },
        ];
        (devPlanStatus === null || devPlanStatus === void 0 ? void 0 : devPlanStatus.status) === 'active' || (devPlanStatus === null || devPlanStatus === void 0 ? void 0 : devPlanStatus.status) === 'trialing'
            ? crumbs.push({
                to: "/organizations/".concat(organizationId, "/developerPlans/usage"),
                text: 'Usage',
            }, {
                to: '',
                text: 'Update Plan',
            })
            : crumbs.push({
                to: '',
                text: 'Developer Plans',
            });
    }
    useEffect(function () {
        if (organizationId) {
            listDeveloperPlans(organizationId);
        }
    }, [listDeveloperPlans, organizationId]);
    useEffect(function () {
        (activeDeveloperPlan === null || activeDeveloperPlan === void 0 ? void 0 : activeDeveloperPlan.id) &&
            selectedPlan &&
            getProRatedAmount(organizationId, selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id);
    }, [
        getProRatedAmount,
        selectedPlan,
        organizationId,
        activeDeveloperPlan === null || activeDeveloperPlan === void 0 ? void 0 : activeDeveloperPlan.id,
    ]);
    useErrorToast('An error occurred while purchasing developer plan', [
        !developerPlanPurchase_loading,
        developerPlanPurchase_error,
    ]);
    useErrorToast('An error occurred while calculating proration', [
        !proRatedAmountLoading,
        proRatedAmountError,
    ]);
    var onSubscribeButtonClick = function (plan) {
        var _a;
        if (((plan === null || plan === void 0 ? void 0 : plan.trial_period) > 0 ? !(plan === null || plan === void 0 ? void 0 : plan.trial_payment_optional) : true) &&
            (paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.default_payment_method) === 'card' &&
            ((_a = paymentDetails.card_payment_method) === null || _a === void 0 ? void 0 : _a.card_valid) !== 1) {
            setSelectedDevPlanId(plan === null || plan === void 0 ? void 0 : plan.id);
            setShowModals(true);
        }
        else {
            setSelectedPlan(plan);
            (devPlanStatus === null || devPlanStatus === void 0 ? void 0 : devPlanStatus.status) === 'active' || (devPlanStatus === null || devPlanStatus === void 0 ? void 0 : devPlanStatus.status) === 'trialing'
                ? setOpenDevPlanUpdateModal(true)
                : setOpenDevPlanConfirmModal(true);
        }
    };
    var onSubscribe = function (update) { return __awaiter(void 0, void 0, void 0, function () {
        var purchase;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    update
                        ? setOpenDevPlanUpdateModal(false)
                        : setOpenDevPlanConfirmModal(false);
                    dispatch(checkOrgStatusSummery(organizationId));
                    return [4 /*yield*/, purchaseDeveloperPlansOrg(organizationId, selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id, [])];
                case 1:
                    purchase = _a.sent();
                    purchase && navigate(pathname.replace('/usage', '/addons'));
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(DevPlanConfirmModal, { isVisible: openDevPlanConfirmModal, setIsVisible: setOpenDevPlanConfirmModal, primaryButtonAction: onSubscribe, selectedPlan: selectedPlan }), _jsx(DevPlanUpdateModal, { isVisible: openDevPlanUpdateModal, setIsVisible: setOpenDevPlanUpdateModal, primaryButtonAction: onSubscribe, selectedPlan: selectedPlan, activeDeveloperPlan: activeDeveloperPlan, proRatedAmountLoading: proRatedAmountLoading, proRatedAmount: proRatedAmount.orgId === organizationId &&
                    proRatedAmount.devPlanId === (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id)
                    ? proRatedAmount
                    : {} }), _jsxs(PageWrapper, { children: [_jsx(Helmet, { children: _jsx("title", { children: "Developer Plans" }) }), _jsx(PageHeader, { children: _jsx(PageHeaderTitle, { children: _jsx(Breadcrumbs, { crumbs: crumbs }) }) }), _jsx(PageContent, { children: _jsx(DevPlanCardWrapper, { purchasedDeveloperPlan: purchasedDeveloperPlan, changeInterval: changeInterval, stripePromise: stripePromise, onSubscribeButtonClick: onSubscribeButtonClick, developerPlanPurchase_loading: developerPlanPurchase_loading, devPlanStatus: devPlanStatus, developerPlans: developerPlans, developerPlans_loading: developerPlans_loading, interval: interval }) })] })] }));
};
var mapStateToProps = function (state) { return (__assign(__assign({ organization: makeSelectOrganization()(state) }, makeSelectDevPlans(state)), { developerPlans: selectFilterdDevPlans(state), paymentDetails: selectPaymentSummery(state), activeDeveloperPlan: makeSelectActiveDeveloperPlan(state), proRatedAmount: selectProRatedAmount(state), proRatedAmountLoading: selectProRatedAmountLoading(state), proRatedAmountError: selectProRatedAmountError(state), devPlanStatus: selectDevPlanSummery(state) })); };
var mapDispatchToProps = function (dispatch) { return ({
    listDeveloperPlans: function (orgId) {
        dispatch(actions.listDeveloperPlansOrg(orgId));
    },
    changeInterval: function (interval) {
        dispatch(actions.changeInterval(interval));
    },
    purchaseDeveloperPlansOrg: function (OrgId, DevPlanId, Bundles) {
        return dispatch(actions.purchaseDeveloperPlansOrg(OrgId, DevPlanId, Bundles));
    },
    setSelectedDevPlanId: function (devPlanId) {
        dispatch(setSelectedDevPlan(devPlanId));
    },
    setShowModals: function (isOpen) {
        dispatch(setCurrentStep(NAVIGATE_STEP_KEYS.CARD_DETAILS));
        dispatch(setShowModals(isOpen));
    },
    getProRatedAmount: function (orgId, devPlanId) {
        dispatch(actions.getProRatedAmount(orgId, devPlanId));
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(OrganizationDeveloperPlans);
